import { useTranslation } from 'react-i18next'

import { Input } from '@/components/ui/input'

import { FormFieldProps } from './dynamic-input'

export const InputName = ({ field, form, inputClassName }: FormFieldProps) => {
  const { t } = useTranslation()
  const content = field?.content

  return (
    <Input
      {...form.register(`${field?.id}`, {
        required: content?.required ? 'Field is required' : false,
      })}
      type="text"
      placeholder={t('enter_your_name')}
      className={inputClassName}
    />
  )
}
